import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Hook para buscar o agregado de notificações
 * Reduz drasticamente leituras do Firebase - lê apenas 1 documento ao invés de todos
 */
export const useNotificationsAggregate = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const notificationsAggregateRef = doc(db, 'agregadoNotificacoes', 'all');
    
    const unsubscribe = onSnapshot(
      notificationsAggregateRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          const notificationsArray = data.notificacoes || [];
          
          // Converter Timestamps para Dates
          const notificationsData = notificationsArray.map((notification) => {
            let criadoEm;
            if (notification.criadoEm?.toDate) {
              criadoEm = notification.criadoEm.toDate();
            } else if (notification.criadoEm?.seconds) {
              // Se for um Timestamp serializado (com seconds e nanoseconds)
              criadoEm = new Date(notification.criadoEm.seconds * 1000);
            } else {
              criadoEm = notification.criadoEm ? new Date(notification.criadoEm) : new Date();
            }
            
            let lidaEm = null;
            if (notification.lidaEm) {
              if (notification.lidaEm?.toDate) {
                lidaEm = notification.lidaEm.toDate();
              } else if (notification.lidaEm?.seconds) {
                lidaEm = new Date(notification.lidaEm.seconds * 1000);
              } else {
                lidaEm = new Date(notification.lidaEm);
              }
            }
            
            return {
              ...notification,
              criadoEm,
              lidaEm
            };
          });
          
          // Ordenar por data de criação (mais recente primeiro)
          notificationsData.sort((a, b) => {
            const dateA = a.criadoEm instanceof Date ? a.criadoEm : new Date(a.criadoEm);
            const dateB = b.criadoEm instanceof Date ? b.criadoEm : new Date(b.criadoEm);
            return dateB.getTime() - dateA.getTime();
          });
          
          setNotifications(notificationsData);
        } else {
          // Se o agregado não existe, retornar array vazio (não lançar erro)
          setNotifications([]);
        }
        
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { notifications, loading, error };
};
